import api from '@/plugins/api'

const state = {
  events: [],
  currentEvent: null,
  loading: false,
  error: null
}

const mutations = {
  SET_EVENTS(state, events) {
    state.events = events
  },
  SET_CURRENT_EVENT(state, event) {
    state.currentEvent = event
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  }
}

const actions = {
  async fetchEvents({ commit }, params) {
    try {
      commit('SET_LOADING', true)
      const response = await api.Event.fetch(params)
      commit('SET_EVENTS', response)
      return response
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchEventById({ commit }, id) {
    try {
      commit('SET_LOADING', true)
      const response = await api.Event.fetchOne(id)
      commit('SET_CURRENT_EVENT', response)
      return response
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async checkIn({ commit }, { id, data }) {
    try {
      commit('SET_LOADING', true)
      const response = await api.Event.checkIn(id, data)
      return response
    } catch (error) {
      console.log('error', error)
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async createEvent({ commit }, data) {
    try {
      commit('SET_LOADING', true)
      const response = await api.Event.create(data)
      return response
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async updateEvent({ commit }, { id, data }) {
    try {
      commit('SET_LOADING', true)
      const response = await api.Event.update(id, data)
      return response
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async deleteEvent({ commit }, id) {
    try {
      commit('SET_LOADING', true)
      const response = await api.Event.remove(id)
      return response
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  }
}

const getters = {
  events: state => state.events,
  currentEvent: state => state.currentEvent,
  loading: state => state.loading,
  error: state => state.error
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} 